import { useAppSelector } from '@/app/hooks';
import FolderNameModal from '@/components/MantineFileManager/FolderNameModal';
import { useCreateFolderMutation } from '@/features/api/endpoints/folderEndpoints';
import { useIsAdmin } from '@/shared/auth/useDirectusUser';
import { useIsXs } from '@/shared/utils/mediaQuery-utils';
import { ActionIcon, Button, Tooltip } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconFolderPlus } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

const CreateFolderBtn = () => {
  const { t } = useTranslate();
  const isXs = useIsXs();

  const isAdmin = useIsAdmin();

  const currentFolderId = useAppSelector(state => state.drive.currentFolderId);
  const [createFolder] = useCreateFolderMutation();

  if (!isAdmin) {
    return null;
  }

  const handleCreateFolder = () => {
    modals.open({
      title: t('folder.create.title'),
      fullScreen: isXs,
      children: (
        <FolderNameModal
          label={t('folder.name')}
          submitLabel={t('folder.create.submit')}
          onSubmit={async name => {
            try {
              await createFolder({
                name,
                parent: currentFolderId ?? null,
              }).unwrap();
              notifications.show({
                color: 'green',
                message: t('folder.create.success'),
              });
            } catch {
              notifications.show({
                color: 'red',
                message: t('folder.create.error'),
              });
            }
          }}
        />
      ),
    });
  };

  return (
    <>
      <Tooltip label={t('folder.create.title')} withArrow>
        <ActionIcon
          onClick={handleCreateFolder}
          aria-label={t('folder.create.title')}
          hiddenFrom="sm"
          variant="light"
        >
          <IconFolderPlus size={18} />
        </ActionIcon>
      </Tooltip>

      <Button
        leftSection={<IconFolderPlus size={18} />}
        onClick={handleCreateFolder}
        visibleFrom="sm"
      >
        {t('folder.create.title')}
      </Button>
    </>
  );
};

export default CreateFolderBtn;
